// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"531":"e14f3256","584":"608284fb"}[chunkId] + ".chunk.js";
};